if (window.location.href.includes("/loyalty")) {
  const urlParams = new URLSearchParams(window.location.search);
  const email = urlParams.get("email");

  if (email) {
    console.log("Email:", email);

    const emailInput = document.getElementById("email");
    if (emailInput) {
      emailInput.value = email;
    }
  } else {
    console.log("Email parameter not found in the URL.");
  }
}
 
 var customPopupLoyalty = document.getElementById('custom-email-loyalty');
  customPopupLoyalty.addEventListener('click', function(e) {
    e.preventDefault();
    var emailPopValue = document.querySelector('input[name="popup-input"]').value;
    window.location.href = "https://www.lenevshop.no/a/loyalty?email=" + encodeURIComponent(emailPopValue);
  });
